import React from 'react';
import * as PropTypes from 'prop-types';
import { Wrapper, Icon, Avatar } from './elements';
import LBLab2 from 'dc/LBLab2';

function ChaMeta11(props) {
  return (
    <Wrapper className={props.className}>
      {props.type === 'user' ? (
        <Avatar
          image={props.avatarImage}
          isLoading={props.isLoadingAvatar}
          onClick={props.onClickAvatar}
        />
      ) : (
        <Icon
          icon={props.groupIcon}
          color={props.indicatorColor || '#00ab97'}
        />
      )}
      <LBLab2
        icon={props.icon}
        name={props.labelText}
        percent={props.percent}
        points={props.value}
        progressColor={props.indicatorColor || '#00ab97'}
        iconColor={props.indicatorColor || '#00ab97'}
      />
    </Wrapper>
  );
}

ChaMeta11.propTypes = {
  className: PropTypes.string,
  type: PropTypes.oneOf(['user', null]),
  groupIcon: PropTypes.string,
  icon: PropTypes.string,
  indicatorColor: PropTypes.string,
  avatarImage: PropTypes.string,
  isLoadingAvatar: PropTypes.bool,
  onClickAvatar: PropTypes.func,
  labelText: PropTypes.string,
  percent: PropTypes.number,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default ChaMeta11;
